// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"807":"e0575e92","925":"9fec1f9f"}[chunkId] + ".css";
};